import {
  responsiveMediaFragment,
  responsiveMediaTransparentFragment,
} from '~/gql/mediaFragments.gql'
import {
  typeFragment,
  localeFragment,
  seoFragment,
  styledBannerFragment
} from './fragments.gql'

import {
  customThemeFragment,
  genericStructuredTextFragment
} from './structuredText.gql'

export default `query FilterPageQuery(
  $locale: SiteLocale, $slug: String, $id: ItemId
) {
  filterPage(${localeFragment}, filter: {
    OR: [
      { slug: { eq: $slug } }
      { id: { eq: $id } }
    ]
  }) {
    id
    slug
    title
    hidePageResultNumber
    summary {
      blocks
      links
      value
    }
    theme {
      ${customThemeFragment}
    }
    ${responsiveMediaFragment('leadImage')}
    campaignBanner {
      ... on StyledBannerRecord {
        ${styledBannerFragment}
      }
      ... on FilterPageBannerRecord {
        ${typeFragment}
        ${responsiveMediaFragment('media', '{ h: "400" }')}
        ${responsiveMediaFragment('mobileMedia', '{ h: "200" }')}
        ${responsiveMediaTransparentFragment('badge', '{ h: "200" }')}
        content {
          ${genericStructuredTextFragment}
        }
      }
    }
    defaultFilters {
      ... on FilterValueRecord {
        displayValue
        filterValue
        belongsToFilterGroup {
          filterGroupDisplayName
          filterGroupValue
          filterKey
          displayKey
        }
      }
      ... on FilterJoinOptionRecord {
        joinValue
      }
    }
    filterLinks {
      slug
      title
    }
    longFormatCopy {
      blocks
      links
      value
    }
    inheritGlobalGalleryAds
    galleryAdPositioning
    resultsPerPage
    infiniteLoadResults
    enableCustomMerchandising
    showInstashop
    instashopProducts {
      id
    }
    ${seoFragment}
  },
  allFilterGroups {
    filterGroupValue
    filterGroupDisplayName
    filterKey
    displayKey
  },
  allFilterBanners {
    id
    portraitBannerStyle
		landscapeBannerStyle
    bannerPosition
    listPosition
    bannerLink
    includeOn {
      id
    }
    ${responsiveMediaFragment('portraitBannerImage', '{ w: "800" }')}
    portraitBannerBackgroundMode
    ${responsiveMediaFragment('portraitBannerMobileImage', '{ w: "600" }')}
    portraitBannerMobileBackgroundMode
    ${responsiveMediaFragment('landscapeBannerImage')}
    content {
      ${genericStructuredTextFragment}
    }
    slug
  }
}`
